import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { Frequency } from "../../../../ViewModel/Frequency";
import { InboundAndReturnFrequency } from "./inboundAndReturnFrequencies";

type FtlRouteFrequencyProps = {
  header: "Return Frequency" | "Inbound Frequency";
  frequency: Frequency | undefined;
  inboundAndReturnFrequencies: InboundAndReturnFrequency[];
  handleChange: (frequency: number) => void;
  disabled?: boolean;
};

export const FtlRouteFrequency = ({
  header,
  frequency,
  inboundAndReturnFrequencies,
  handleChange,
  disabled = false,
}: FtlRouteFrequencyProps) => {
  const determineFrequency = (
    freq: Frequency | undefined,
    frequencies: InboundAndReturnFrequency[]
  ): InboundAndReturnFrequency => {
    return freq === undefined
      ? {
          text: inboundAndReturnFrequencies[0].text,
          value: inboundAndReturnFrequencies[0].value,
        }
      : {
          text: getFrequencyDisplayNameOrFallback(freq, frequencies),
          value: freq,
        };
  };

  const getFrequencyDisplayNameOrFallback = (
    freq: number,
    frequencies: InboundAndReturnFrequency[]
  ): string => {
    const foundFreq = frequencies.find((f) => f.value === freq);
    return foundFreq === undefined ? "-" : foundFreq.text;
  };

  return (
    <>
      <span>{header}</span>
      <DropDownList
        data={inboundAndReturnFrequencies}
        textField="text"
        dataItemKey="value"
        value={determineFrequency(frequency, inboundAndReturnFrequencies)}
        onChange={(event: DropDownListChangeEvent) => handleChange(event.target.value.value)}
        disabled={disabled}
      />
    </>
  );
};
